export const ckEditorType = {
    BASIC: 'basic',
    FULL: 'full',
    SIMPLE_WITH_MENTIONS: 'simple_with_mentions',
};

export const ckEditorExtraPlugins = {
    [ckEditorType.BASIC]: 'autogrow,justify',
    //TODO: need to add more to this list
    [ckEditorType.FULL]: 'autogrow,justify,colorbutton,font',
    [ckEditorType.SIMPLE_WITH_MENTIONS]: 'autogrow,mentions',
};

export const ckEditorConfig = {
    [ckEditorType.BASIC]: [
        { name: 'basicActions', items: ['Undo', 'Redo'] },
        { name: 'basicStyles', items: ['Bold', 'Italic', 'Underline'] },
        { name: 'basicLists', items: ['NumberedList', 'BulletedList'] },
        { name: 'justifyContent', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
        { name: 'basicFunctions', items: ['Cut', 'Copy', 'Paste'] },
        { name: 'links', items: ['Link', 'Unlink'] },
    ],
    //the full version one will require additional plugins to be included in the extraPlugins prop of ckEditor
    [ckEditorType.FULL]: [
        { name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
        { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
        { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
        '/',
        {
            name: 'basicstyles',
            items: [
                'Bold',
                'Italic',
                'Underline',
                'Strike',
                'Subscript',
                'Superscript',
                '-',
                'CopyFormatting',
                'RemoveFormat',
            ],
        },
        {
            name: 'paragraph',
            items: [
                'NumberedList',
                'BulletedList',
                '-',
                'Outdent',
                'Indent',
                '-',
                'Blockquote',
                'CreateDiv',
                '-',
                'JustifyLeft',
                'JustifyCenter',
                'JustifyRight',
                'JustifyBlock',
                '-',
                'BidiLtr',
                'BidiRtl',
                'Language',
            ],
        },
        { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
        { name: 'insert', items: ['Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
        '/',
        { name: 'styles', items: ['Font', 'FontSize'] },
        { name: 'colors', items: ['TextColor'] },
        { name: 'about', items: ['About'] },
    ],
    //we do not need any editor for mentions - for now
    [ckEditorType.SIMPLE_WITH_MENTIONS]: [
        { name: 'basicStyles', items: ['Bold', 'Italic', 'Underline'] },
        { name: 'links', items: ['Link', 'Unlink'] },
        { name: 'basicLists', items: ['NumberedList', 'BulletedList'] },
    ],
};

export const getExtraPlugins = (type) => {
    return type && ckEditorExtraPlugins[type] ? ckEditorExtraPlugins[type] : '';
};

export const getCkEditorType = (type) => {
    return type && ckEditorConfig[type] ? ckEditorConfig[type] : ckEditorConfig[ckEditorType.BASIC];
};
